import {ChevronRightIcon} from '@primer/octicons-react'
import {ActionList, ActionMenu} from '@primer/react'

export const WhitespacePreference = {
  AlwaysShow: 'always_show',
  AlwaysHide: 'always_hide',
  HideForCurrentDiff: 'hide_for_current_diff',
} as const

export type WhitespacePreference = (typeof WhitespacePreference)[keyof typeof WhitespacePreference]

export interface WhitespacePreferenceFlyoutProps {
  preference: WhitespacePreference
  onSelect: (preference: WhitespacePreference) => void
}

const OPTIONS: Array<{
  description: string
  label: string
  value: WhitespacePreference
}> = [
  {
    description: 'Show in all files.',
    label: 'Always show',
    value: WhitespacePreference.AlwaysShow,
  },
  {
    description: 'Hide in all files.',
    label: 'Always hide',
    value: WhitespacePreference.AlwaysHide,
  },
  {
    description: 'Other diffs stay unchanged.',
    label: 'Hide for this diff only',
    value: WhitespacePreference.HideForCurrentDiff,
  },
]

export function WhitespacePreferenceFlyout({preference, onSelect}: WhitespacePreferenceFlyoutProps) {
  const selectedOption = OPTIONS.find(option => option.value === preference)

  return (
    <ActionList.Group aria-label="Whitespace changes" selectionVariant="single">
      <ActionMenu>
        <ActionMenu.Anchor>
          <ActionList.Item role="menuitem">
            Whitespace changes
            <ActionList.Description variant="block">{selectedOption?.label}</ActionList.Description>
            <ActionList.TrailingVisual>
              <ChevronRightIcon />
            </ActionList.TrailingVisual>
          </ActionList.Item>
        </ActionMenu.Anchor>
        <ActionMenu.Overlay side="outside-bottom" align="end">
          <ActionList>
            <ActionList.Group aria-label="Whitespace changes" selectionVariant="single">
              {OPTIONS.map(option => (
                <ActionList.Item
                  key={option.value}
                  selected={option.value === preference}
                  onSelect={() => onSelect(option.value)}
                >
                  {option.label}
                  <ActionList.Description variant="block">{option.description}</ActionList.Description>
                </ActionList.Item>
              ))}
            </ActionList.Group>
          </ActionList>
        </ActionMenu.Overlay>
      </ActionMenu>
    </ActionList.Group>
  )
}
